import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../../../shared/util.service';
import { Hotel } from 'app/shared/model';
import { DateService } from 'app/shared/services/date.service';

@Component({
    selector: 'mh-online-executive-section',
    templateUrl: './online-executive-section.component.html',
    standalone: false
})
export class OnlineExecutiveSectionsComponent implements OnInit {
  productId = 3;

  filters = ['iro', 'nps', 'average_rating', 'reviews_quantity', 'promoter_percentage', 'detractors_percentage'];

  metricsActions: { [key: string]: string } = {
    iro: 'getIRO',
    nps: 'getHistoricNPS',
    average_rating: 'getAverageRating',
    reviews_quantity: 'getReviewsQuantity',
    promoter_percentage: 'getPromoterPercentage',
    detractors_percentage: 'getDetractorsPercentage',
  };

  fidelityPermisions: string[] = [];
  chain: Hotel[] = [];

  filtersData: any = {};
  filterSelected: any = {};
  filtersTypes: string[] = [];
  filtersAreas: number[] = [];

  surveysReady = false;

  constructor(private utilService: UtilService, private dateService: DateService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.chain = this.utilService.getInnerChain(false, 'online');
    }, 0);
    this.fidelityPermisions = this.utilService.getFidelityConfigurationsByProduct('interchain', 'interchain_online');
    this.initializeFilters();
  }

  private initializeFilters(): void {
    this.filtersData['metrics'] = this.metricsActions;
    this.filterSelected['metrics'] = this.filters[0];
    this.filtersTypes = ['metrics'];
  }

  onAreasAvailable(areas: number[]): void {
    const areasActions: { [key: number]: string } = {};
    areas.forEach(areaId => {
      areasActions[areaId] = `area_${areaId}`;
    });

    this.filtersAreas = areas;
    this.filterSelected['areas'] = areas[0];
    this.filtersData['areas'] = areasActions;
    if (!this.filtersTypes.includes('areas')) {
      this.filtersTypes.push('areas');
    }
  }

  setSelectValue($event: any, key: string): void {
    this.filterSelected = {
      ...this.filterSelected,
      [key]: $event.value,
    };

    if (key === 'metrics') {
      if ($event.value !== 'area') {
        this.filtersTypes = this.filtersTypes.filter(type => type !== 'areas');
        delete this.filterSelected['areas'];
        delete this.filtersData['areas'];
        this.filtersAreas = [];
      }
    }
  }

  handleDatepickerUpdated($event) {
    this.dateService.setCurrentFilter($event.currentFilter);
    this.dateService.setCurrentDates($event.currentDates);
  }

  get currentDates() {
    return this.dateService.currentDates;
  }

  get startDate() {
    return this.currentDates.startDate;
  }

  get endDate() {
    return this.currentDates.endDate;
  }

  get currentFilterDate() {
    return this.dateService.currentFilter;
  }

  onSurveysLoaded(surveysReady: boolean): void {
    this.surveysReady = !surveysReady;
  }
}
